// Module
var code = `<graph-threshold-form panel-ctrl="ctrl"></graph-threshold-form>
`;
// Exports
var _module_exports =code;;
var path = 'public/app/plugins/panel/graph/tab_thresholds.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;